import React from 'react';
import common from '../styles/Pages.module.css';
import styles from '../styles/Company.module.css';

const Company = () => {

    const pub = process.env.PUBLIC_URL;

    return (
        <div className={common.pages}>
            <div className={common.page}>
                <div className={styles.companyOne}>
                    {/* <div className={styles.plus}>
                        <div className={styles.horizontal}></div>
                        <div className={styles.vertical}></div>
                    </div> */}
                    <div className={styles.companyText}>
                        <span>ABOUT</span>
                        <p>회사소개</p>
                    </div>
                    <span className={styles.backTitle}>OFFERGROUP</span>
                    <div className={styles.companyTBox}>
                        <div className={styles.pBox}>
                            <p>(주)오퍼그룹은 2021년에 법인으로 설립되었으며 고객에게 최고의 가치를 제공하며,</p>
                            <p>고객과 함께 동반 성장합니다.</p>
                        </div>
                        <div className={styles.pBox}>
                            <p>저희의 핵심 가치는 존중을 바탕으로 협력하여 개인, 기업, 직원과 같이 더불어</p>
                            <p>"동반 성장"할 수 있는 기업을 목표로 추구합니다.</p>
                        </div>
                        <div className={styles.pBox}>
                            <p>저희의 서비스로 모든 사업주분들의 사업을 지키고 발전하는데 도움이 되길 바라며</p>
                            <p>좋은 인연으로 귀사의 성공 파트너가 되겠습니다.</p>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div className={styles.tBox}>
                        <p>BUSINESS SOLUTION COMPANY</p>
                    </div>
                    <img src={`${pub}/main/3p/001.png`} alt="1p" />
                    <img src={`${pub}/main/3p/002.png`} alt="2p" />
                    <img src={`${pub}/main/3p/003.png`} alt="3p" />
                </div>
            </div>
            <div className={common.page}>
                {/* <img style={{zIndex: -1}} src={`${process.env.PUBLIC_URL}/main/4p/4p.png`} alt='2page' /> */}
                <div className={styles.companyTwo}>
                    <div className={styles.companyText}>
                        <span>ABOUT</span>
                        <p>회사소개</p>
                    </div>
                    <span className={styles.backTitle}>SALESFIGUIDES</span>
                    <div className={styles.tBox}>
                        <div className={styles.title}>
                            <p>주요실적</p>
                            <div className={styles.divider}>
                                <div className={styles.dividerThick}></div>
                                <div className={styles.dividerThin}></div>
                            </div>
                        </div>
                        <div className={styles.content}>
                            <div className={styles.pBoldBox}>
                                <p>고객사의 성장이 곧 (주)오퍼그룹의 성과입니다.</p>
                            </div>
                            <div className={styles.pBox}>
                                <p>(주)오퍼그룹은 플랫폼회사로서</p>
                                <p>개인 그리그 기업에게 맞춤형 솔루션을 제공하여</p>
                                <p>신속하고 정확한 서비스로 동반 성장을 목표합니다.</p>
                            </div>
                            <div className={styles.pBox}>
                                <p>다년간의 경험을 바탕으로 플랫폼을 개발하였으며,</p>
                                <p>플랫폼 서비스를 통해 서비스를 제공하여</p>
                                <p>고객사의 효율성과 매출을 크게 향상 시킬 수 있도록 하였습니다.</p>
                            </div>
                            <div className={styles.pBox}>
                                <p>또한 동반 성장을 모티브로 강력한 파트너십을 구축하였고,</p>
                                <p>지속적인 협력과 성공을 전략적으로 지원하는</p>
                                <p>파트너의 역할을 하고있습니다.</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.imgArea}>
                        <img className={styles.img01} src={`${pub}/main/4p/004.png`} alt="원큐브"/>
                        <img className={styles.img02} src={`${pub}/main/4p/005.png`} alt="열쇠큐브"/>
                        <img className={styles.img03} src={`${pub}/main/4p/006.png`} alt="이중원큐브"/>
                    </div>
                    <div className={styles.circleArea}>
                        <div className={styles.circle}>
                            <p>118억</p>
                            <p>2023년 매출</p>
                        </div>
                        <div className={styles.circle}>
                            <p>1000곳</p>
                            <p>국내 파트너사</p>
                            <p>제휴 기업</p>
                        </div>
                    </div>
                    <div className={styles.backLogo}>
                        <img src={`${pub}/main/2p/2p-오퍼그룹로고_수정.png`} alt='뒷배경로고' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Company;
